export const MERCHANT_LOGO_MAX_BYTES = 1024 * 1024;
export const MERCHANT_LOGO_SIZE_ERROR =
  "Image size should not exceed 1MB";
export const MERCHANT_LOGO_TYPE_ERROR =
  "Only jpg/jpeg, png, and svg files are allowed!";

const MERCHANT_LOGO_ALLOWED_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "svg",
]);

export const isValidMerchantLogoExtension = (filename) => {
  const ext = String(filename || "")
    .split(".")
    .pop()
    ?.toLowerCase();

  return MERCHANT_LOGO_ALLOWED_EXTENSIONS.has(ext || "");
};

export const validateMerchantLogoFile = (file) => {
  if (!file) {
    return { valid: false, error: MERCHANT_LOGO_TYPE_ERROR };
  }

  if (file.size > MERCHANT_LOGO_MAX_BYTES) {
    return { valid: false, error: MERCHANT_LOGO_SIZE_ERROR };
  }

  if (!isValidMerchantLogoExtension(file.name)) {
    return { valid: false, error: MERCHANT_LOGO_TYPE_ERROR };
  }

  return { valid: true, error: "" };
};
